export default __webpack_public_path__ + "static/media/rozan.595ba1ae.png";